<template>
  <GmapMap :center="{ lat: latitude, lng: longitude }" :zoom="zoom" class="google-map">
    <GmapMarker
        :position="{ lat: latitude, lng: longitude }"
        :clickable="clickable"
        :draggable="draggable"
    />
  </GmapMap>
</template>

<script>
export default {
  props: {
    latitude: { type: Number, default: 51.5322 },
    longitude: { type: Number, default: 0.2449 },
    zoom: { type: Number, default: 16 },
    clickable: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
  },
  data() {
    return {
      markers: [],
    };
  },
};
</script>
